/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Prepared_Action_Not_PendingInputs */

const en_error_prepared_action_not_pending = /** @type {(inputs: Error_Prepared_Action_Not_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action no longer waits for you: it was confirmed, discarded, expired, or the token or connection that prepared it was revoked.`)
};

/**
* | output |
* | --- |
* | "This action no longer waits for you: it was confirmed, discarded, expired, or the token or connection that prepared it was revoked." |
*
* @param {Error_Prepared_Action_Not_PendingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_prepared_action_not_pending = /** @type {((inputs?: Error_Prepared_Action_Not_PendingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Prepared_Action_Not_PendingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_prepared_action_not_pending(inputs)
});